import { hasPermission, saveRedirect } from '@/helpers';
import store from '@/store'

const handleError = (error, next, to) => {
  if (error.response && (error.response.status === 403 || error.response.status === 401) && !(error.response.data && error.response.data.valid)) {
    localStorage.removeItem('token');
    store.commit('authentication/setError', 'Session expired. Please login again')
    saveRedirect(to.fullPath);
    return next({ path: '/' });
  }

  // fail closed when validation could not complete (e.g. network error): keep
  // the token — it may still be valid — but do not admit the protected route
  if (!error.response) {
    store.commit('authentication/setError', 'Could not verify your session. Please try again.')
    saveRedirect(to.fullPath);
    return next({ path: '/' });
  }

  return next();
}

const validateToken = (next, to) =>
  store.dispatch('authentication/validate')
  .then((user) => {
    if (user instanceof Error) {
      return handleError(user, next, to)
    }

    if (!hasPermission(user.role, to.meta.role)) {
      return next({
        path: '/notfound',
      });
    }

    return next();
  })
  .catch((error) => handleError(error, next, to));

export default validateToken;
